import { useNavigate, useSearchParams } from 'react-router-dom';
import Layout from '../components/Layout';

export default function CheckoutFail() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const message = searchParams.get("message") || "결제가 취소되었습니다";

  return (
    <Layout>
      <div style={{ maxWidth: 480 }}>
        <div style={{ background: "#161B27", border: "0.5px solid #2A3045", borderRadius: 12, padding: 40, textAlign: "center" as const }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}>❌</div>
          <div style={{ color: "#F56565", fontSize: 20, fontWeight: 700, marginBottom: 8 }}>결제 실패</div>
          <div style={{ color: "#8892A4", fontSize: 14 }}>{message}</div>
          <button onClick={() => navigate("/pricing")}
            style={{ background: "#00D4AA", border: "none", borderRadius: 8, padding: "12px 32px", color: "#0A1F18", fontSize: 14, fontWeight: 700, cursor: "pointer", marginTop: 24 }}>
            다시 시도
          </button>
        </div>
      </div>
    </Layout>
  );
}
